import { app } from '../../app';
import { Controller } from './sp-blocked-status.controller';

app.component('spBlockedStatus', {
    bindings: {
        blockedStatus: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-blocked-status.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-blocked-status/sp-blocked-status.component.js